"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setMediaTheme = exports.setMediaShareOfAudience = exports.setMediaShareOfAttribute = exports.setMediaPopulation = exports.setMediaIndex = exports.resetMediaTheme = exports.resetMediaShareOfAudience = exports.resetMediaShareOfAttribute = exports.resetMediaPopulation = exports.resetMediaIndex = exports.SET_MEDIA_THEME = exports.SET_MEDIA_POPULATION = exports.SET_MEDIA_INDEX = exports.RESET_MEDIA_THEME = exports.RESET_MEDIA_SHARE_OF_AUDIENCE = exports.RESET_MEDIA_SHARE_OF_ATTRIBUTE = exports.RESET_MEDIA_POPULATION = exports.RESET_MEDIA_INDEX = exports.SET_MEDIA_SHARE_OF_AUDIENCE = exports.SET_MEDIA_SHARE_OF_ATTRIBUTE = void 0;
var SET_MEDIA_SHARE_OF_ATTRIBUTE = 'SET_MEDIA_SHARE_OF_ATTRIBUTE';
exports.SET_MEDIA_SHARE_OF_ATTRIBUTE = SET_MEDIA_SHARE_OF_ATTRIBUTE;
var SET_MEDIA_SHARE_OF_AUDIENCE = 'SET_MEDIA_SHARE_OF_AUDIENCE';
exports.SET_MEDIA_SHARE_OF_AUDIENCE = SET_MEDIA_SHARE_OF_AUDIENCE;
var RESET_MEDIA_INDEX = 'RESET_MEDIA_INDEX';
exports.RESET_MEDIA_INDEX = RESET_MEDIA_INDEX;
var RESET_MEDIA_POPULATION = 'RESET_MEDIA_POPULATION';
exports.RESET_MEDIA_POPULATION = RESET_MEDIA_POPULATION;
var RESET_MEDIA_SHARE_OF_ATTRIBUTE = 'RESET_MEDIA_SHARE_OF_ATTRIBUTE';
exports.RESET_MEDIA_SHARE_OF_ATTRIBUTE = RESET_MEDIA_SHARE_OF_ATTRIBUTE;
var RESET_MEDIA_SHARE_OF_AUDIENCE = 'RESET_MEDIA_SHARE_OF_AUDIENCE';
exports.RESET_MEDIA_SHARE_OF_AUDIENCE = RESET_MEDIA_SHARE_OF_AUDIENCE;
var RESET_MEDIA_THEME = 'RESET_MEDIA_THEME';
exports.RESET_MEDIA_THEME = RESET_MEDIA_THEME;
var SET_MEDIA_INDEX = 'SET_MEDIA_INDEX';
exports.SET_MEDIA_INDEX = SET_MEDIA_INDEX;
var SET_MEDIA_POPULATION = 'SET_MEDIA_POPULATION';
exports.SET_MEDIA_POPULATION = SET_MEDIA_POPULATION;
var SET_MEDIA_THEME = 'SET_MEDIA_THEME';
exports.SET_MEDIA_THEME = SET_MEDIA_THEME;

var resetMediaIndex = function resetMediaIndex() {
  return {
    type: RESET_MEDIA_INDEX
  };
};

exports.resetMediaIndex = resetMediaIndex;

var resetMediaPopulation = function resetMediaPopulation() {
  return {
    type: RESET_MEDIA_POPULATION
  };
};

exports.resetMediaPopulation = resetMediaPopulation;

var resetMediaShareOfAttribute = function resetMediaShareOfAttribute() {
  return {
    type: RESET_MEDIA_SHARE_OF_ATTRIBUTE
  };
};

exports.resetMediaShareOfAttribute = resetMediaShareOfAttribute;

var resetMediaShareOfAudience = function resetMediaShareOfAudience() {
  return {
    type: RESET_MEDIA_SHARE_OF_AUDIENCE
  };
};

exports.resetMediaShareOfAudience = resetMediaShareOfAudience;

var resetMediaTheme = function resetMediaTheme(value) {
  return {
    type: RESET_MEDIA_THEME,
    payload: value
  };
};

exports.resetMediaTheme = resetMediaTheme;

var setMediaIndex = function setMediaIndex(value) {
  return {
    type: SET_MEDIA_INDEX,
    payload: value
  };
};

exports.setMediaIndex = setMediaIndex;

var setMediaPopulation = function setMediaPopulation(value) {
  return {
    type: SET_MEDIA_POPULATION,
    payload: value
  };
};

exports.setMediaPopulation = setMediaPopulation;

var setMediaShareOfAttribute = function setMediaShareOfAttribute(value) {
  return {
    type: SET_MEDIA_SHARE_OF_ATTRIBUTE,
    payload: value
  };
};

exports.setMediaShareOfAttribute = setMediaShareOfAttribute;

var setMediaShareOfAudience = function setMediaShareOfAudience(value) {
  return {
    type: SET_MEDIA_SHARE_OF_AUDIENCE,
    payload: value
  };
};

exports.setMediaShareOfAudience = setMediaShareOfAudience;

var setMediaTheme = function setMediaTheme(value) {
  return {
    type: SET_MEDIA_THEME,
    payload: value
  };
};

exports.setMediaTheme = setMediaTheme;